import { EVENT } from "@/constants/event";
import useAppStore from "@/context/store";
import { getGrocery } from "@/services";
import { useRafInterval } from "ahooks";
import { useState } from "react";
interface Notice {
  visible: boolean;
  content: string;
}
export function useRafIntervalNotice() {
  const isClient = typeof window !== "undefined";
  const { globalNotice = {} } = useAppStore(({ globalNotice }) => ({
    globalNotice,
  }));
  // 只有在客户端时候再循环请求
  const [interval] = useState(
    isClient && globalNotice?.visible && globalNotice.content ? 5000 : undefined
  );

  const clear = useRafInterval(async () => {
    const res = (await getGrocery("global-notice")) as Notice;
    // 当配置关闭时候，关闭公告并停止循环
    const showNotice = res?.visible && res?.content;

    if (!showNotice) {
      closeNotice();
    }
  }, interval);
  const closeNotice = () => {
    clear();
    window.dispatchEvent(new Event(EVENT.CLOSE_GLOABL_BANNER));
  };
}
